angular.module('app.financeiro').factory('remessaPagamentoFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'RemessaPagamento';

    var _addNew = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AddNew');
    };

    var _list = function (search, options, dataInicio, dataTermino, situacao, tipoRemessa, filtrarPorDataInclusao) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": situacao });
        dto.parms.push({ "name": "TipoRemessa", "value": tipoRemessa });
        dto.parms.push({ "name": "FiltrarPorDataInclusao", "value": filtrarPorDataInclusao });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _incluirRemessa = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/IncluirRemessa', dto);
    };

    var _gerarRemessa = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/GerarRemessa', dto);
    };

    var _cancelarRemessa = function (codigo) {
        var dto = {};
        dto.id = codigo;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Remove', dto);
    };

    var _selecionaPropostaPagamento = function (search, options, codigoBanco, isAdd, codigoRemessa, dataInicio, dataTermino, codigoProdutoRede, listaPropostas, codigoCessao) {
        var dto = options.data;
        dto.search = search;

        if (listaPropostas == null)
            listaPropostas = "";

        dto.parms = [];
        dto.parms.push({ "name": "CodigoBanco", "value": codigoBanco });
        dto.parms.push({ "name": "isAdd", "value": isAdd ? "SIM" : "NAO" });
        dto.parms.push({ "name": "CodigoRemessa", "value": codigoRemessa });
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });
        dto.parms.push({ "name": "ListaPropostas", "value": listaPropostas.toString() });
        dto.parms.push({ "name": "CodigoCessao", "value": codigoCessao });

        $("[kendo-grid][data-role='grid']").data("kendoGrid").parms = dto.parms;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SelecionaPropostaPagamento', dto);
    };

    var _incluirPropostas = function (codigo, propostas, dataInicio, dataTermino, codigoProdutoRede, listaPropostas, converterTEDemPIX, nsuCredito) {
        var dto = {};
        dto.Codigo = codigo;
        dto.Propostas = propostas;
        dto.dtInicio = dataInicio;
        dto.dtTermino = dataTermino;
        dto.CodigoProdutoRede = codigoProdutoRede;
        dto.ListaPropostas = (listaPropostas ?? '').toString();
        dto.ConverterTEDemPIX = converterTEDemPIX;
        dto.NSUCredito = nsuCredito;

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/IncluirPropostas', dto);
    };

    var _selecionaPropostaFinalizacao = function (options, codigoBanco, codigoRemessa) {
        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "CodigoBanco", "value": codigoBanco });
        dto.parms.push({ "name": "CodigoRemessa", "value": codigoRemessa });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SelecionaPropostaFinalizacao', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _selecionaPropostaDetalhe = function (options, codigoBanco, codigoRemessa) {
        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "CodigoBanco", "value": codigoBanco });
        dto.parms.push({ "name": "CodigoRemessa", "value": codigoRemessa });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SelecionaPropostaDetalhe', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _finalizar = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Finalizar', dto);
    };

    var _validaHorarioModeloTransferencia = function (modelo) {
        var dto = {};
        dto.id = modelo;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ValidaHorarioModeloTransferencia', dto);
    };

    var _listSituacaoPagamento = function (search, options, dataInicio, dataTermino, situacao, statusRetorno, codigoProdutoRede, listagemResumida, listaPropostas) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": situacao });
        dto.parms.push({ "name": "StatusRetorno", "value": statusRetorno });
        dto.parms.push({ "name": "ListagemResumida", "value": listagemResumida });
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });

        if (listaPropostas && listaPropostas.length > 0) dto.parms.push({ "name": "ListaPropostas", "value": JSON.stringify(listaPropostas) });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SituacaoPagamento', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _consultaSaldoConta = function (id) {

        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ConsultaSaldoConta', dto);
    };

    var _consultaExtratoContaUltimoMes = function (parametroBancoPagamento) {

        var dto = {};
        dto.id = parametroBancoPagamento;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ConsultaExtratoContaUltimoMes', dto);
    }

    var _colocarRemessaEmAnalise = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ColocarRemessaEmAnalise', dto);
    };

    var _colocarRemessaEmIniciada = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ColocarRemessaEmIniciada', dto);
    };

    var factory = {};

    factory.addNew = _addNew;
    factory.list = _list;
    factory.findRecord = _findRecord;
    factory.incluirRemessa = _incluirRemessa;
    factory.gerarRemessa = _gerarRemessa;
    factory.cancelarRemessa = _cancelarRemessa;
    factory.selecionaPropostaPagamento = _selecionaPropostaPagamento;
    factory.incluirPropostas = _incluirPropostas;
    factory.selecionaPropostaFinalizacao = _selecionaPropostaFinalizacao;
    factory.selecionaPropostaDetalhe = _selecionaPropostaDetalhe;
    factory.finalizar = _finalizar;
    factory.listSituacaoPagamento = _listSituacaoPagamento;
    factory.validaHorarioModeloTransferencia = _validaHorarioModeloTransferencia;
    factory.consultaSaldoConta = _consultaSaldoConta;
    factory.colocarRemessaEmAnalise = _colocarRemessaEmAnalise;
    factory.colocarRemessaEmIniciada = _colocarRemessaEmIniciada;
    factory.consultaExtratoContaUltimoMes = _consultaExtratoContaUltimoMes;

    return factory;

}]);
